
import { useAuth } from "@/contexts/AuthContext";
import { useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { User } from "lucide-react";

export default function ProfilePage() {
  const { currentUser } = useAuth();

  useEffect(() => {
    document.title = "Profile | Shekel";
  }, []);

  if (!currentUser) {
    return null;
  }

  return (
    <div className="max-w-2xl mx-auto">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Profile</h1>
        <p className="text-gray-600 mt-2">Your account information</p>
      </div>

      <Card>
        <CardHeader className="flex flex-row items-center space-y-0 pb-4">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-shekel-100 rounded-full flex items-center justify-center">
              {currentUser.image ? (
                <img 
                  src={currentUser.image} 
                  alt="Profile" 
                  className="w-12 h-12 rounded-full object-cover"
                />
              ) : (
                <User className="w-6 h-6 text-shekel-600" />
              )}
            </div>
            <div>
              <CardTitle className="text-xl">
                {currentUser.firstName} {currentUser.lastName}
              </CardTitle>
              <Badge variant={currentUser.role === 'parent' ? 'default' : 'secondary'}>
                {currentUser.role === 'parent' ? 'Parent' : 'Child'}
              </Badge>
            </div>
          </div>
        </CardHeader>
        
        <CardContent className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-medium text-gray-700">First Name</label>
              <div className="mt-1 p-3 bg-gray-50 border rounded-md">
                {currentUser.firstName}
              </div>
            </div>
            
            <div>
              <label className="text-sm font-medium text-gray-700">Last Name</label>
              <div className="mt-1 p-3 bg-gray-50 border rounded-md">
                {currentUser.lastName}
              </div>
            </div>
            
            <div className="md:col-span-2">
              <label className="text-sm font-medium text-gray-700">Email</label>
              <div className="mt-1 p-3 bg-gray-50 border rounded-md">
                {currentUser.username}
              </div>
            </div>
            
            <div>
              <label className="text-sm font-medium text-gray-700">Role</label>
              <div className="mt-1 p-3 bg-gray-50 border rounded-md capitalize">
                {currentUser.role}
              </div>
            </div>
            
            {currentUser.role === 'child' && (
              <div>
                <label className="text-sm font-medium text-gray-700">Balance</label>
                <div className="mt-1 p-3 bg-gray-50 border rounded-md">
                  ₪{currentUser.balance.toFixed(2)}
                </div>
              </div>
            )}
            
            <div className="md:col-span-2">
              <label className="text-sm font-medium text-gray-700">Family ID</label>
              <div className="mt-1 p-3 bg-gray-50 border rounded-md font-mono text-sm">
                {currentUser.familyId}
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
